/**
 * Creates a Promise that resolves after a specified delay.
 * 
 * @param {number} [ms=500] - The number of milliseconds to wait before resolving the promise
 * @returns {Promise<void>} A Promise that resolves after the specified delay
 * 
 * @example
 * // Wait for 1 second
 * await wait(1000);
 * 
 * @example
 * // Wait for default 500ms
 * await wait();
 * 
 * @example
 * // Use with .then() syntax
 * wait(2000).then(() => {
 *   console.log('2 seconds have passed');
 * });
*/
export function wait(ms: number = 500) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}